
import { FileItem } from "@/pages/admin/files/types";
import { StorageEngine } from "./storageEngine";
import { logStorage } from "./storageUtils";

// File storage class built on top of the generic storage engine
class FileStorageManager {
  private storageEngine: StorageEngine<FileItem>;

  constructor() {
    this.storageEngine = new StorageEngine<FileItem>('adminFiles', 'FileStorage');
  }

  // Get all files from storage
  getAllFiles(): FileItem[] {
    return this.storageEngine.getAllItems();
  }

  // Save a single file to storage
  saveFile(file: FileItem): FileItem {
    return this.storageEngine.saveItem(file);
  }

  // Save multiple files to storage - completely replace existing files
  saveFiles(files: FileItem[]): FileItem[] {
    return this.storageEngine.saveItems(files);
  }
  
  // Add multiple files to existing storage without replacing all files
  addFiles(newFiles: FileItem[]): FileItem[] {
    return this.storageEngine.addItems(newFiles);
  }

  // Delete a file from storage
  deleteFile(fileId: number): boolean {
    return this.storageEngine.deleteItem(fileId);
  }

  // Update a file in storage
  updateFile(fileId: number, updatedFile: Partial<FileItem>): FileItem | null {
    return this.storageEngine.updateItem(fileId, updatedFile);
  }
  
  // Get files by category
  getFilesByCategory(category: string): FileItem[] {
    logStorage("FileStorage", "Getting files by category:", category);
    return this.storageEngine.filterItems(file => file.category === category);
  }
  
  // Debug helper to dump all files to console
  debugDumpStorage(): void {
    this.storageEngine.debugDumpStorage();
  }
}

// Create and export a singleton instance
export const fileStorage = new FileStorageManager();
